const HisLawFirmIcon = ({ color, sx }) => {
  const _sx = sx ?? {};
  const strokeColor = color ?? "#0B4EDB";
  return (
    <svg
      style={_sx}
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.6851 27.2629L31.6885 13.9204L36.6919 27.2629C35.2409 28.3469 33.4897 28.9307 31.6885 28.9307C29.8872 28.9307 28.136 28.3469 26.6851 27.2629Z"
        stroke={strokeColor}
        strokeWidth="3.33561"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33545 27.2629L8.33887 13.9204L13.3423 27.2629C11.8913 28.3469 10.1401 28.9307 8.33887 28.9307C6.53764 28.9307 4.78644 28.3469 3.33545 27.2629Z"
        stroke={strokeColor}
        strokeWidth="3.33561"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6748 35.6021H28.3529"
        stroke={strokeColor}
        strokeWidth="3.33561"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0137 5.58154V35.602"
        stroke={strokeColor}
        strokeWidth="3.33561"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.00342 12.2526H8.33903C11.6746 12.2526 16.6781 10.5848 20.0137 8.91699C23.3493 10.5848 28.3527 12.2526 31.6883 12.2526H35.0239"
        stroke={strokeColor}
        strokeWidth="3.33561"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisLawFirmIcon;
